import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const TextArea = (props) => {
  return (
    <div className="textarea_group">
      <textarea
        onChange={props.onChange}
        defaultValue={props.value}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        name={props.name}
        required={props.required}
        disabled={props.disabled}
      />
      <span className="textarea_label">{props.label}</span>
    </div>
  );
};
TextArea.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};
TextArea.defaultProps = {
  label: '',
  placeholder: ' ',
  value: '',
  maxLength: 256,
  name: null,
  required: false,
  disabled: false,
  onChange: () => {},
};

export default TextArea;
